import React, { useEffect, useState } from 'react';
import { useSpring } from '@react-spring/web';
import { useInView } from 'react-intersection-observer';

import { ContainerMobile, Line, AnimatedLine, CircleMobile } from './ProgressLine.styled';

export interface Props {
    useCircle?: boolean;
}

const ProgressLineMobile: React.FC<Props> = props => {
    const { useCircle = false } = props;
    const { ref: containerRef, inView, entry } = useInView({ threshold: 0.7 });

    const [hasScrolledPast, setHasScrolledPast] = useState<boolean>(false);

    const heightSpring = useSpring({
        height: hasScrolledPast ? '4rem' : inView ? '4rem' : '0',
        config: { mass: 1, tension: 200, friction: 60 }
    });

    useEffect(() => {
        if (!inView && entry?.boundingClientRect) {
            entry.boundingClientRect.top < 0 ? setHasScrolledPast(true) : setHasScrolledPast(false);
        }
    }, [inView]);

    return (
        <ContainerMobile ref={containerRef}>
            <Line />
            <AnimatedLine style={heightSpring} />
            {useCircle && <CircleMobile $active={inView} />}
        </ContainerMobile>
    );
};

export default ProgressLineMobile;
